import React from 'react';
import CmsContentList from 'components/data/CmsContentList.js';
import CmsContentRenderer from 'components/data/CmsContentRenderer.js';
import Banner, { TYPE_WARNING } from 'components/Banner.js';
import { getPathByRoute } from 'App.js';
import routeKeys from 'CustomerRouteKeys.js';

import Button, { buttonTypeStylePlain } from 'components/Button.js';
import * as style from './RegisterForAccount.module.css';
import { shortYear } from 'utils/FormatHelpers.js';
import { getCardExpiryDate } from 'components/card-icons/util';


const cms = {
	title: 'miscText["card-overview-banner-charlie-expiring.title"]',
	description: 'miscText["card-overview-banner-charlie-expiring.description"]',
	link: 'miscText["card-overview-banner-charlie-expiring.button"]',
};

const ExpiringClosedLoop = ({ primaryToken, transit_account_id }) => {
	// Format to MM/YY
	const expirationDateISO = getCardExpiryDate(primaryToken?.tokenInfo);
	const expirationDate = new Date(expirationDateISO);

	const month = expirationDate.getMonth() + 1;

	const formattedMonth = month < 10
		? `0${month}`
		: month;
	const year = shortYear(expirationDate.getFullYear());

	const formattedExpiration = `${formattedMonth}/${year}`;

	return <CmsContentList sharedVariables={{ date: formattedExpiration }} list={Object.values(cms)}>{() => (
		<Banner
			type={TYPE_WARNING}
			title={<CmsContentRenderer
				contentKey={cms.title}
				fallbackValue={"Charlie Card Expiring Soon"}

			/>}
			body={<CmsContentRenderer
				contentKey={cms.description}
				fallbackValue={`This Charlie Card is valid until ${formattedExpiration}`}
				variables={{ date: formattedExpiration }}
			/>}
			link={
				<Button
					to={getPathByRoute(routeKeys.AccountCardBlockOrReplace, { transit_account_id, replacedTravelTokenId: primaryToken.id })}
					typeStyle={buttonTypeStylePlain}
					additionalClassNames={style.registerButtonOverride}
				>
					<CmsContentRenderer.Span contentKey={cms.link} fallbackValue="Order Replacement" />
				</Button>
			}
		/>
	)}</CmsContentList>;
};

export default ExpiringClosedLoop;
